interface IConditionalWrapper {
  condition: boolean;
  wrapper: (children: JSX.Element) => JSX.Element;
  children: JSX.Element;
}
export function ConditionalWrapper({
  condition,
  wrapper,
  children,
}: IConditionalWrapper) {
  return condition ? wrapper(children) : children;
}
